<template>
	<div class="section-row section-row--double-314-min mb--34">
		<div class="row-item">
			<div class="field-row">
				<field-select
					:options="fontOptions"
					v-model:selected="model.fontSelected"
					:property="'name'"
					:by-value="'value'"
				></field-select>
				<field-select
					:options="weightOptions"
					:disabled="!model.fontSelected"
					v-model:selected="model.weightSelected"
					:property="'name'"
				></field-select>
			</div>
		</div>
		<div class="row-item">
			<div class="field-row">
				<field-regular
					v-if="showFontSize"
					:label-icon="'fas fa-text-height'"
					:label-inline="true"
					:field-classname="'field--w-50'"
					:unit="'px'"
					:field-item-grow="false"
					:numbers-only="true"
					:return-null-if-empty="true"
					v-model:model-value="model.fontSize"
				></field-regular>
				<field-regular
					v-if="showLineHeight"
					:label-icon="'fas fa-arrows-alt-v'"
					:label-inline="true"
					:field-classname="'field--w-50'"
          :unit="'em'"
					:disabled="!model.fontSize"
					:field-item-grow="false"
					:type="FIELD_TYPES.FLOAT"
					v-model:model-value="model.lineHeight"
				></field-regular>
			</div>
		</div>
	</div>
</template>

<script>
import FieldSelect from '@/components/fields/FieldSelect';
import FieldRegular from '@/components/fields/FieldRegular';
import {FIELD_TYPES} from '@/models/FIELD_TYPES';
import {computed, reactive} from 'vue';

export default {
	components: {
		FieldSelect,
		FieldRegular
	},
	props: {
		fontOptions: {
			type: Array
		},
		fontSelected: {
			type: [String, Object]
		},
		weightOptions: {
			type: Array
		},
		weightSelected: {
			type: [String, Object]
		},
		fontSize: {
			type: [Number, Object]
		},
		showFontSize: {
			type: Boolean,
			default: true
		},
		lineHeight: {
			type: [Number, Object]
		},
		showLineHeight: {
			type: Boolean,
			default: true
		}
	},
	setup(props, {emit}) {
		const fontSelected = computed({
			get(){return props.fontSelected},
			set(value){
				emit('update:fontSelected', value)
			}
		})
		const weightSelected = computed({
			get(){return props.weightSelected},
			set(value){
        emit('update:weightSelected', value)
      }
		})
		const fontSize = computed({
			get(){return props.fontSize},
			set(value){emit('update:fontSize', value)}
		})
		const lineHeight = computed({
			get(){return props.lineHeight},
			set(value){emit('update:lineHeight', value)}
		})
		const model = reactive({
			fontSelected,
			weightSelected,
			fontSize,
			lineHeight
		})
		return {
			model,
			FIELD_TYPES
		}
	}
}
</script>

<style lang="scss">

</style>
